import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";

type Lead = Tables<"leads">;

export const CampaignInformation = ({ lead }: { lead: Lead }) => {
  if (!lead.utm_source && !lead.utm_medium && !lead.utm_campaign) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Campaign Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {lead.utm_source && (
          <div>
            <div className="font-medium">UTM Source</div>
            <div>{lead.utm_source}</div>
          </div>
        )}
        {lead.utm_medium && (
          <div>
            <div className="font-medium">UTM Medium</div>
            <div>{lead.utm_medium}</div>
          </div>
        )}
        {lead.utm_campaign && (
          <div>
            <div className="font-medium">UTM Campaign</div>
            <div>{lead.utm_campaign}</div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};